import { notificationWidgets } from 'features';
import { Widgets as notificationTodoWidgets } from './Todos';

export const Widgets = {
  ...notificationTodoWidgets,
  ...notificationWidgets,
};
